// Formatação e cores do relatório de CMV — as mesmas faixas dos cards do topo.
const MOEDA = { minimumFractionDigits: 2, maximumFractionDigits: 2 };

export const fmtR$ = (v) => `R$ ${Number(v || 0).toLocaleString("pt-BR", MOEDA)}`;
export const fmtPct = (v) => `${Number(v || 0).toFixed(1).replace(".", ",")}%`;

export const marginColor = (m) =>
  m >= 50 ? "text-emerald-600 dark:text-emerald-400"
    : m >= 30 ? "text-green-600 dark:text-green-400"
      : m >= 15 ? "text-amber-600 dark:text-amber-400"
        : "text-red-600 dark:text-red-400";

export const marginBg = (m) =>
  m >= 50 ? "bg-emerald-500" : m >= 30 ? "bg-green-500" : m >= 15 ? "bg-amber-500" : "bg-red-500";

export const getImageUrl = (url) => {
  if (!url) return null;
  if (url.startsWith("data:") || url.startsWith("http")) return url;
  return `/api${url}`;
};
